import { createFileRoute } from "@tanstack/react-router";
import LegalNoticePage from "@/pages/legal/LegalNoticePage";

export const Route = createFileRoute("/legal")({
  head: () => ({
    meta: [
        {
            "title": "Mentions légales | System Atlas"
        },
        {
            "name": "description",
            "content": "Mentions légales de System Atlas : éditeur, hébergement, propriété intellectuelle et responsabilités."
        },
        {
            "property": "og:title",
            "content": "Mentions légales | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Mentions légales de System Atlas : éditeur, hébergement, propriété intellectuelle et responsabilités."
        },
        {
            "property": "og:type",
            "content": "website"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/legal"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Mentions légales | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Mentions légales de System Atlas : éditeur, hébergement, propriété intellectuelle et responsabilités."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/legal"
        }
    ],
  }),
  component: LegalNoticePage,
});
